import * as R from 'remeda';
import { Reducer } from 'redux';
import { getType } from 'typesafe-actions';
import { v4 as uuidv4 } from 'uuid';
import { BboxT } from '../../../types/bbox';
import { RootActionType } from '../../rootActions';
import { clearAnnotationData } from '../annotation/actions';
import { leaveValidation } from '../ui/actions';
import { fetchBboxes, fetchBboxesFulfilled } from './actions';

const initialState: { [page: number]: BboxT } = {};

const bboxesReducer: Reducer<typeof initialState, RootActionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case getType(fetchBboxes):
    case getType(leaveValidation):
    case getType(clearAnnotationData):
      return initialState;

    case getType(fetchBboxesFulfilled): {
      return R.groupBy(
        action.payload.map(bbox => ({ ...bbox, __internal_id: uuidv4() })),
        b => b.page
      );
    }

    default:
      return state;
  }
};

export default bboxesReducer;
